export default __webpack_public_path__ + "static/media/cartWheel.e9bc1194.png";